<template>
  <span :style="{ display: 'inline-flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', fontSize: '12px', color: 'var(--p-surface-400)' }">
    <span v-for="(k, i) in keys" :key="k" :style="{ display: 'inline-flex', alignItems: 'center', gap: '6px' }">
      <span v-if="i > 0" :style="{ opacity: 0.4, marginRight: '4px' }">·</span>
      <FormatValue :record="record" :field-key="k" :field-definitions="fieldDefinitions" :field-meta="fieldMeta" />
    </span>
  </span>
</template>

<script setup>
// Inline status fields (· separated) for list rows. Ported from collection-frame
// StatusBits — uses the shared FormatValue so every surface formats identically.
import FormatValue from '@/admin-collection-layout/lib/formatValue.js'

defineProps({
  record: { type: Object, required: true },
  fieldDefinitions: { type: Object, required: true },
  fieldMeta: { type: Object, default: () => ({}) },
  keys: { type: Array, default: () => [] },
})
</script>
